module.exports = __webpack_public_path__ + "media/src/assets/images/planet-df6ce62629d13b28d334238d6dfca4e0.svg";